import asyncComponent from "./components/AsyncComponent";
import { isLogin } from "./imports/protectors";

import Logout from "./pages/logout/Logout";

// import CourseListPage from './pages/course-list/CourseListDS';
// import CourseDetailPage from './pages/course-detail/CourseDetailDS';
// import HomePage from './pages/home/HomeDS';
// import LoginPage from './pages/login-register/LoginDS';
// import MyProgramsPage from './pages/my-programs/MyProgramsDS';
// import ProgramPage from './pages/program/ProgramDs';
// import ProfilePage from './pages/profile/ProfileDs';
// import AboutPage from './pages/about/AboutDS';
// import FaqPage from './pages/faq/FaqDS';
// import ContactUsPage from './pages/contact-us/ContactUsDS';
// import TeacherListPage from './pages/teacher-list/TeacherListDS';
// import TeacherDetailPage from './pages/teacher-detail/TeacherDetailDS';
// import EnrollmentPage from './pages/enroll-in-program/EnrollmentDS';
// import CompanyEnrollmentPage from './pages/company-enrollment/CompanyEnrollmentDS';
// import Rule1Page from './pages/rule-1/Rule1Ds';
// import Rule2Page from './pages/rule-2/Rule2Ds';
import MainComponent from "./pages/main/MainComponent";
import NotificationsPage from "./pages/notifications/NotificationsPage";
// import CoursePage from './pages/course/CourseDS';

const Rule2Page = asyncComponent(() =>
    import("./pages/rule-2/Rule2Ds").then(module => module.default)
);

const Rule1Page = asyncComponent(() =>
    import("./pages/rule-1/Rule1Ds").then(module => module.default)
);

const CompanyEnrollmentPage = asyncComponent(() =>
    import("./pages/company-enrollment/CompanyEnrollmentDS").then(
        module => module.default
    )
);

const TeacherDetailPage = asyncComponent(() =>
    import("./pages/teacher-detail/TeacherDetailDS").then(
        module => module.default
    )
);

const TeacherListPage = asyncComponent(() =>
    import("./pages/teacher-list/TeacherListDS").then(module => module.default)
);

const ContactUsPage = asyncComponent(() =>
    import("./pages/contact-us/ContactUsDS").then(module => module.default)
);

const FaqPage = asyncComponent(() =>
    import("./pages/faq/FaqDS").then(module => module.default)
);

const AboutPage = asyncComponent(() =>
    import("./pages/about/AboutDS").then(module => module.default)
);

const ProfilePage = asyncComponent(() =>
    import("./pages/profile/ProfileDs").then(module => module.default)
);

const HomePage = asyncComponent(() =>
    import("./pages/home/HomeDS")
        .then(module => module.default)
        .catch(err => console.error(err))
);

const CourseDetailPage = asyncComponent(() =>
    import("./pages/course-detail/CourseDetailDS").then(
        module => module.default
    )
);

const CourseListPage = asyncComponent(() =>
    import("./pages/course-list/CourseListDS").then(module => module.default)
);

const LoginPage = asyncComponent(() =>
    import("./pages/login-register/LoginDS").then(module => module.default)
);

const ProgramPage = asyncComponent(() =>
    import("./pages/program/ProgramDs").then(module => module.default)
);

const EnrollmentPage = asyncComponent(() =>
    import("./pages/enroll-in-program/EnrollmentDS").then(
        module => module.default
    )
);

const MyProgramsPage = asyncComponent(() =>
    import("./pages/my-programs/MyProgramsDS").then(module => module.default)
);

const ChatListPage = asyncComponent(() =>
    import("./pages/chat-list/ChatListDS").then(module => module.default)
);

const NotificationPage = asyncComponent(() =>
    import("./pages/notifications/NotificationsDS").then(
        module => module.default
    )
);

const ChatPage = asyncComponent(() =>
    import("./pages/chat/ChatDS").then(module => module.default)
);

const CoursePage = asyncComponent(() =>
    import("./pages/course/CourseDS").then(module => module.default)
);

const AboutMbaCoursePage = asyncComponent(() =>
    import("./pages/about-mba-course/AboutMbaCoursePage").then(
        module => module.default
    )
);

const ExamPage = asyncComponent(() =>
    import("./pages/exam/ExamDs").then(module => module.default)
);

const NotFoundPage = asyncComponent(() =>
    import("./pages/not-found/NotFoundPage").then(module => module.default)
);

const ProgramsListPage = asyncComponent(() =>
    import("./pages/programs-list/ProgramsListDS").then(module => module.default)
);

const ProgramDetailPage = asyncComponent(() =>
    import("./pages/program-detail/ProgramDetailDS").then(module => module.default)
);

const InvoicesListPage = asyncComponent(() =>
    import("./pages/invoices-list/InvoicesListDS").then(module => module.default)
);

const InvoiceDetailPage = asyncComponent(() =>
    import("./pages/invoice-detail/InvoiceDetailDS").then(module => module.default)
);


const routes = [
    {
        exact: true,
        path: "/",
        component: MainComponent
    },
    {
        exact: true,
        path: "/home",
        component: HomePage
    },
    {
        exact: true,
        path: "/invoices",
        component: InvoicesListPage
    },
    {
        exact: true,
        path: "/invoices/:id",
        component: InvoiceDetailPage
    },
    {
        exact: true,
        path: "/courses",
        component: CourseListPage
    },
    {
        exact: true,
        path: "/course/:id",
        component: CourseDetailPage
    },
    {
        exact: true,
        path: "/programs",
        component: ProgramsListPage
    },
    {
        // exact: true,
        path: "/program/:id",
        component: ProgramDetailPage
    },
    {
        exact: false,
        path: "/execute/program/:programId/course/:courseId",
        component: CoursePage,
        isPrivate: true
    },
    {
        exact: true,
        path: "/teachers",
        component: TeacherListPage
    },
    {
        exact: true,
        path: "/teacher/:id",
        component: TeacherDetailPage
    },
    {
        exact: true,
        path: "/faq",
        component: FaqPage
    },
    {
        exact: true,
        path: "/about-us",
        component: AboutPage
    },
    {
        exact: true,
        path: "/contact",
        component: ContactUsPage
    },
    {
        exact: true,
        path: "/login",
        component: LoginPage
    },
    {
        exact: true,
        path: "/my-programs",
        component: MyProgramsPage,
        protectors: [isLogin]
    },
    {
        exact: true,
        path: "/chat-list",
        component: ChatListPage,
        protectors: [isLogin]
    },
    {
        exact: true,
        path: "/chat/:id",
        component: ChatPage,
        protectors: [isLogin]
    },
    {
        exact: true,
        path: "/execute/program/:id",
        component: ProgramPage
    },
    {
        exact: true,
        path: "/profile",
        component: ProfilePage
    },
    {
        exact: true,
        path: "/logout",
        component: Logout
    },
    {
        exact: false,
        path: "/enrollment/:programId",
        component: EnrollmentPage
    },
    {
        exact: true,
        path: "/company-enrollment",
        component: CompanyEnrollmentPage
    },
    {
        exact: true,
        path: "/rules/1",
        component: Rule1Page
    },
    {
        exact: true,
        path: "/rules/2",
        component: Rule2Page
    },
    {
        exact: false,
        path: "/mba-program",
        component: AboutMbaCoursePage
    },
    {
        exact: true,
        path: "/exam/:id",
        component: ExamPage
    },
    {
        exact: true,
        path: "/notifications",
        component: NotificationPage
    },
    {
        exact: true,
        path: "/404",
        component: NotFoundPage
    }
];

export default routes;
